import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAIL,
  GET_UNREAD_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS_SUCCESS,
  GET_UNREAD_NOTIFICATIONS_FAIL,
  DELETE_ALL_NOTIFICATIONS,
  DELETE_ALL_NOTIFICATIONS_SUCCESS,
  DELETE_ALL_NOTIFICATIONS_FAIL,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAIL,
  MARK_AS_READ,
} from "./actionTypes";
import {
  getNotifications,
  getNotificationsSuccess,
  getNotificationsFail,
  getUnreadNotifications,
  getUnreadNotificationsSuccess,
  getUnreadNotificationsFail,
  DeleteAllNotificationsSuccess,
  DeleteAllNotificationsFail,
  DeleteNotificationSuccess,
  DeleteNotificationFail,
  MarkAsReadFail,
  MarkAsReadSuccess,
} from "./actions";
import { takeEvery, put, call, select } from "redux-saga/effects";
import axios from "axios";
import toast from "react-hot-toast";
import { url } from "APIs/URLS";

const getNotificationsAPI = async token => {
  try {
    console.log("token in saga", token);
    const response = await axios.get(`${url}/Settings/getNotifications`, {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer  ${token}`,
      },
    });
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* getNotificationsList() {
  // let user = yield select(getUser);
  var token = JSON.parse(localStorage.getItem("authUser")).refresh_token;
  try {
    const response = yield call(getNotificationsAPI, token);
    console.log("notifications", response);
    yield put(getNotificationsSuccess(response));
  } catch (error) {
    yield put(getNotificationsFail(error));
  }
}

//GET UNREAD NOTIIFCATIONS

const getUnreadNotificationsAPI = async token => {
  try {
    console.log("token in saga", token);
    const response = await axios.get(`${url}/Settings/getUnreadNotifications`, {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer  ${token}`,
      },
    });
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* getUnreadNotificationsList() {
  // let user = yield select(getUser);
  // var token = user.refresh_token;
  let token = JSON.parse(localStorage.getItem("authUser")).refresh_token;
  try {
    const response = yield call(getUnreadNotificationsAPI, token);
    console.log("notifications", response);
    yield put(getUnreadNotificationsSuccess(response));
  } catch (error) {
    yield put(getUnreadNotificationsFail(error));
  }
}

//DELETE ALL NOTIFICATIONS
const DeleteAllNotificationsAPI = async token => {
  console.log("token in saga", token);
  const myPromise = axios.delete(`${url}/Settings/deleteAllNotifications`, {
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer  ${token}`,
    },
  });
  try {
    toast.promise(myPromise, {
      loading: "Deleting All Notifications..",
      success: "All Notifications Deleted Successfully",
      error: "Error Deleting Notifications",
    });
    const response = await myPromise;

    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* DeleteAllNotificationsList() {
  // let user = yield select(getUser);
  // var token = user.refresh_token;
  var token = JSON.parse(localStorage.getItem("authUser")).refresh_token;
  try {
    const response = yield call(DeleteAllNotificationsAPI, token);
    console.log("notifications", response);
    yield put(DeleteAllNotificationsSuccess(response));
  } catch (error) {
    yield put(DeleteAllNotificationsFail(error));
  }
}

//DELETE SINGLE NOTIIFCATION
const DeleteNotificationAPI = async (token, id) => {
  console.log("token in saga", token);
  const mypromise = axios.delete(`${url}/Settings/deleteNotification/${id}`, {
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer  ${token}`,
    },
  });
  try {
    toast.promise(mypromise, {
      loading: "Deleting Notification..",
      success: "Notificationy Deleted Successfully",
      error: "Error Deleting Notificationy",
    });

    const response = await mypromise;

    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* DeleteNotification({ payload: id }) {
  // let user = yield select(getUser);
  var token = JSON.parse(localStorage.getItem("authUser")).refresh_token;
  try {
    const response = yield call(DeleteNotificationAPI, token, id);
    console.log("notifications", response);
    yield put(DeleteNotificationSuccess(response));
  } catch (error) {
    yield put(DeleteNotificationFail(error));
  }
}

//Mark as read
const MarkAsReadAPI = async (token, id) => {
  console.log("token in saga", token);
  try {
    const response = await axios.post(`${url}/Settings/markAsRead/${id}`, {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer  ${token}`,
      },
    });
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* MarkAsRead({ payload: { token, id } }) {
  try {
    const response = yield call(MarkAsReadAPI, token, id);

    console.log("notifications", response);
    yield put(MarkAsReadSuccess(response));
  } catch (error) {
    yield put(MarkAsReadFail(error));
  }
}

function* NotificationsSaga() {
  yield takeEvery(GET_NOTIFICATIONS, getNotificationsList);
  yield takeEvery(GET_UNREAD_NOTIFICATIONS, getUnreadNotificationsList);
  yield takeEvery(DELETE_ALL_NOTIFICATIONS, DeleteAllNotificationsList);
  yield takeEvery(DELETE_NOTIFICATION, DeleteNotification);
  yield takeEvery(MARK_AS_READ, MarkAsRead);
}

export default NotificationsSaga;
